import { render, staticRenderFns } from "./RequiredAmountTable.vue?vue&type=template&id=3f8550a7&scoped=true&"
import script from "./RequiredAmountTable.vue?vue&type=script&lang=js&"
export * from "./RequiredAmountTable.vue?vue&type=script&lang=js&"
import style0 from "./RequiredAmountTable.vue?vue&type=style&index=0&id=3f8550a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8550a7",
  null
  
)

export default component.exports